import { JSConn } from "@/utilities/js-conn";
import { DOMAIN_URL } from "@/constants";

export default {
  name: "calendarFeedCreate",
  data() {
    return {
      dataLoaded: false,
    };
  },
  computed: {
    calendarUrl: function() {
      const tokenId = this.$store.getters.calendarUrl.token_id;
      const token = this.$store.getters.calendarUrl.token;

      return `webcal://${DOMAIN_URL}/calendar/${tokenId}/${token}`;
    },
  },
  methods: {
    generateCalendarUrl() {
      const jsConn = new JSConn();
      jsConn.formParams = {};

      let storeDispatch;

      storeDispatch = "createCalendarUrl";

      this.$store.dispatch(storeDispatch, jsConn).then(jsConn => {
        this.dataLoaded = true;
        return Promise.resolve(jsConn);
      });
    },
  },
};
